import { render, staticRenderFns } from "./contract-transfer.vue?vue&type=template&id=4f1cfe8e&scoped=true"
import script from "./contract-transfer.vue?vue&type=script&lang=js"
export * from "./contract-transfer.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=4f1cfe8e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1cfe8e",
  null
  
)

export default component.exports